export const getLoggedInUserId = state => state.user.userId;
export const getLoggedInUser = state => state.user;
export const getIsUserLoggedIn = state => state.user.userId != null;